module.exports = __webpack_public_path__ + "static/media/agility_logo.e43b15c1.webp";